<script lang="ts">
	import { PrimaryDrop } from '#lib/websites/primary/pages/PrimaryDrop/index.js';
</script>

<PrimaryDrop />
